import './styles/index.css';

import React, { Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';

// import configureAppStore, { getPreloadedState } from './store/configureStore';
import configureAppStore from '@store/store';

import AppContextProvider from './contexts/AppContextProvider';

import AppRoutes from './routes/AppRoutes';

import { I18nextProvider } from 'react-i18next';
import i18n from './constants/langConfig';
import LanguageSwitcher from '@components/LanguageSwitcher/LanguageSwitcher';

import { Amplify } from 'aws-amplify';
import '@aws-amplify/ui-react/styles.css';
import amplifyconfig from './amplifyconfiguration.json';
import { BatchWritePermissions } from '@utils/dynamoDB';
import {
    DEVICE_TABLE,
    HOSPITALS_TABLE,
    PERMISSIONS_TABLE,
    PERMISSION_ROLE_TABLE,
} from '@constants/dynamoDBTableName';
import permissions from './dynamoDB/permissions_table';
import permissionRole from './dynamoDB/permissions_role';
import deviceList from './dynamoDB/device_table';
import hospitals from './dynamoDB/hospitals_table';
import { AuditLogProvider } from './contexts/AuditLogContext';
// import { Authenticator } from '@aws-amplify/ui-react';
import { requestNotificationPermission, onMessageListener } from '@services/pushNotification';
import { setPushNotificationToken } from '@store/reducers/userSlice';
import NotificationHandler from '@components/NotificationHandler';

// Firebase Service Worker Registration
if ('serviceWorker' in navigator) {
    navigator.serviceWorker
        .register('/firebase-messaging-sw.js')
        .then((registration) => {
            // console.log('Service Worker registered:', registration);
        })
        .catch((error) => console.error('Service Worker registration failed:', error));
}

requestNotificationPermission().then((token) => {
    if (token) {
        // console.log("Push Notification Token:", token);
        configureAppStore.dispatch(setPushNotificationToken(token));
    }
});

// onMessageListener().then((payload) => {
//     console.log("Foreground Notification:", payload);
//     alert(`New notification: ${payload.notification?.title}`);
// }).catch((err) => console.error("Error receiving message:", err));

Amplify.configure(amplifyconfig);

(async () => {
    // const preloadedState = getPreloadedState();
    const LazyLoadedComponent = lazy(() => import('@components/LazyComponent'));
    // const root = createRoot(document.getElementById('root'));
    const root = createRoot(document.getElementById('root')!);

    root.render(
        <React.StrictMode>
            <ReduxProvider store={configureAppStore}>
                <AppContextProvider>
                    <AuditLogProvider>
                        {/* <Authenticator> */}
                        {/* <div className="absolute right-0 pr-3 pt-3">
                        <LanguageSwitcher />
                    </div> */}
                        {/* <button
                        className="border"
                        onClick={() =>
                            BatchWritePermissions(
                                permissions,
                                PERMISSIONS_TABLE
                            )
                        }
                    >
                        Add permissions
                    </button> */}
                        {/* <button
                        className="border"
                        onClick={() =>
                            BatchWritePermissions(hospitals, HOSPITALS_TABLE)
                        }
                    >
                        Add hospitals
                    </button> */}
                        {/* <button
                        className="border"
                        onClick={() =>
                            BatchWritePermissions(
                                permissionRole,
                                PERMISSION_ROLE_TABLE
                            )
                        }
                    >
                        Add permissions Role
                    </button> */}
                        {/* <button
                        className="border"
                        onClick={() =>
                            BatchWritePermissions(deviceList, DEVICE_TABLE)
                        }
                    >
                        Add device
                    </button> */}
                        <I18nextProvider i18n={i18n}>
                            <div className="font-sans">
                                <NotificationHandler />
                                <AppRoutes />
                                {/* <Suspense fallback={<div>Loading...</div>}>
                            <LazyLoadedComponent />
                        </Suspense> */}
                            </div>
                        </I18nextProvider>
                        {/* </Authenticator> */}
                    </AuditLogProvider>
                </AppContextProvider>
            </ReduxProvider>
        </React.StrictMode>
    );
})();
